export default {
  data() {
    return {
      showAsFirstColDropdown: [
        {
          options: [],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("clientSyncs.list.stopped"),
              key: "stopped_at",
              method: () => {
                this.changeCol({
                  list: "clientSyncs",
                  showAs: {
                    firstCol: {
                      label: "clientSyncs.list.stopped",
                      key: "stopped_at",
                      format: "dateTime",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("clientSyncs.list.created"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "clientSyncs",
                  showAs: {
                    firstCol: {
                      label: "clientSyncs.list.created",
                      key: "created_at",
                      format: "dateTime",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("clientSyncs.list.updated"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "clientSyncs",
                  showAs: {
                    firstCol: {
                      label: "clientSyncs.list.updated",
                      key: "updated_at",
                      format: "dateTime",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
    };
  },
};
